import { render, staticRenderFns } from "./aboutMember.vue?vue&type=template&id=6c91d544&"
import script from "./aboutMember.vue?vue&type=script&lang=js&"
export * from "./aboutMember.vue?vue&type=script&lang=js&"
import style0 from "./aboutMember.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports